// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 672) return "bootstrap.undefine.css";
	if (chunkId === 531) return "531.31d6cfe0.css";
	if (chunkId === 179) return "main.31d6cfe0.css";
	// return url for filenames based on template
	return "" + chunkId + "." + {"272":"31d6cfe0","276":"31d6cfe0","419":"31d6cfe0","563":"0c34bea4","718":"31d6cfe0","761":"31d6cfe0"}[chunkId] + ".chunk.css";
};